










import '@bkwld/vue-tooltip/index.css'
import VueTooltip from '@bkwld/vue-tooltip'

export default

	components: { VueTooltip }

